import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconFileSizeLimit = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 21,
	viewBox: "0 0 20 21",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M8.69045 19.5795H4.72371C3.73819 19.5795 2.79303 19.1879 2.09617 18.4911C1.3993 17.7942 1.00781 16.8491 1.00781 15.8636V12.9745C1.00781 9.79859 2.2694 6.75288 4.51505 4.50724C6.7607 2.26159 9.80643 1 12.9823 1H14.0135C14.9989 1 15.9442 1.39149 16.641 2.08836C17.3378 2.78523 17.7294 3.73037 17.7294 4.71589V9.76942",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1 13.1324C1 8.33889 6.10939 12.2033 9.10994 9.19345C12.1105 6.18363 8.27386 1 13.0581 1",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19.3527 15.3536C19.548 15.1583 19.548 14.8417 19.3527 14.6464L16.1707 11.4645C15.9755 11.2692 15.6589 11.2692 15.4636 11.4645C15.2684 11.6597 15.2684 11.9763 15.4636 12.1716L18.2921 15L15.4636 17.8284C15.2684 18.0237 15.2684 18.3403 15.4636 18.5355C15.6589 18.7308 15.9755 18.7308 16.1707 18.5355L19.3527 15.3536ZM11.9277 15.5H18.9992V14.5H11.9277V15.5Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.64728 14.6464C7.45202 14.8417 7.45202 15.1583 7.64728 15.3536L10.8293 18.5355C11.0245 18.7308 11.3411 18.7308 11.5364 18.5355C11.7316 18.3403 11.7316 18.0237 11.5364 17.8284L8.70794 15L11.5364 12.1716C11.7316 11.9763 11.7316 11.6597 11.5364 11.4645C11.3411 11.2692 11.0245 11.2692 10.8293 11.4645L7.64728 14.6464ZM15.0723 14.5L8.00084 14.5L8.00084 15.5L15.0723 15.5L15.0723 14.5Z",
			fill: "currentColor"
		})
	]
});
export default SvgIconFileSizeLimit;
